import React, { useEffect } from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { setEmployees } from "state/slices/user/userSlice";
import { useGetUsersQuery } from "state/slices/user/userApiSlice";

import Employee from "components/Employee";

const EmployeesViewManagement = ({
  teamId,
  isAllowedToUpdate=false,
  isAllowedToDelete=false,
  deleteEmployee = () => {},
  handleEditEmployee = () => {},
}) => {

  const dispatch = useDispatch();

  let employees = useSelector((state) => state.employee.employees);

  // Retrieve Employee
  const { data: users, refetch } = useGetUsersQuery();

  useEffect(() => {
    if (users) {
      // Check if the component is still mounted before updating the state
      dispatch(setEmployees(users));
    }
  }, [users]);

  useEffect(() => {
    refetch();
  }, [employees]);

  // Filter employee results for team
  if ( teamId ) {
    employees = employees.filter(employee => employee.team.id === teamId);
  }

  return (
    <Row>
      {(!employees || employees.length === 0) && (
        Array.from({ length: 8 }).map((_, idx) => (
          <Col lg={3} key={`placeholder-${idx}`}>
            <Card className="all-em-card placeholder-card" style={{ minHeight: 250 }}>
              <div className="all-e-img">
                <span
                  className="placeholder placeholder-lg rounded-circle"
                  style={{ width: "100px", height: "100px", display: "block", margin: "0 auto" }}
                ></span>
                <h5 className="card-title mt-3">
                  <span className="placeholder placeholder-lg col-6"></span>
                </h5>
                <p className="mb-0">
                  <span className="placeholder col-7"></span>
                </p>
              </div>
            </Card>
          </Col>
        ))
      )}
      {employees && employees.length > 0 &&
        employees.map((employee, index) => (
          <Col
            lg={employee?.designation?._id === employee.id ? 4 : 3}
            key={employee.id}
          >
            <Employee
              employee={employee}
              deleteEmployee={deleteEmployee}
              handleEdit={handleEditEmployee}
              isAllowedToUpdate={isAllowedToUpdate}
              isAllowedToDelete={isAllowedToDelete}
            />
          </Col>
        ))}
    </Row>
  );
};

export default EmployeesViewManagement;
